<template>
  <div class="error-note" role="alert">
    <FontAwesomeIcon icon="fa-solid fa-exclamation-triangle" />
    <span>{{ message }}</span>
    <button
      type="button"
      class="btn btn-sm btn-link ms-auto p-0"
      @click="$emit('retry')"
    >
      {{ $t("forwards.common.retry") }}
    </button>
  </div>
</template>

<script setup lang="ts">
/** A failed load's sentence with the one action that helps; margins come from the call site's `class`. */
defineProps<{ message: string }>();
defineEmits<{ retry: [] }>();
</script>
